// posts/KeenelandFeels.jsx
import React from "react";
import "../../../css/BlogArticle.css";

export default function KeenelandFeels() {
  return (
    <div className="blog-article">
      <div className="blog-callout">
        <strong>Quick take:</strong> Keeneland isn’t just a racetrack — it’s a
        full Kentucky experience. Arrive early, explore the grounds, and soak
        in the tradition.
      </div>

      <p>
        Looking for a fun day date, family day trip, or girls’ or guys’ day out?
        Look no further than the Bluegrass State’s peak attraction — Keeneland.
        Kentucky is well known for its horse races, but Keeneland brings it to a
        whole new level of prestige.
      </p>

      <p>
        This world-renowned horse racetrack, founded in 1936 in Lexington,
        Kentucky, hosts annual fall and spring races and is also known worldwide
        for its Thoroughbred yearling auction sales.
      </p>

      <p>
        Since 1984, The Breeders’ Cup — a culminating championship for the
        sport — has closed each year with an international horse race to answer
        the question of who is the best in the world.
      </p>

      <h2>The Secretariat Connection</h2>
      <p>
        The annual Secretariat Festival in October features tours of a nearby
        farm where the famous American racehorse Secretariat lived and was
        buried upon his death in 1989.
      </p>

      <p>
        Still holding the record for the fastest time in all three races of The
        Triple Crown, this Thoroughbred inspired the 2010 movie{" "}
        <em>Secretariat</em>, which was also filmed in part at Keeneland.
      </p>

      {/* Replace with local asset */}
      <figure className="blog-figure">
        <img
          src="/imgs/blog/keeneland/track.jpeg"
          alt="Keeneland racetrack groomed for spring racing"
          loading="lazy"
        />
        <figcaption className="blog-figcaption">
          Keeneland racetrack prepared for spring racing in Lexington, Kentucky
        </figcaption>
      </figure>

      <h2>A Full Day of Fun at Keeneland</h2>
      <p>
        Make a whole day of it and arrive early for the pre-race tailgating in
        the paved parking spots or on <strong>The Hill</strong>.
      </p>

      <p>
        The Hill is a designated tailgating spot that is open on Fridays and
        Saturdays, offering live racing views on a jumbo TV, food trucks, live
        music, betting, and more. Premium tailgating packages are also
        available.
      </p>

      <p>
        The Hill is accessible at no charge and has a complimentary shuttle
        service to the Grandstand area. Parking (paved, handicap, and unpaved —
        excluding buses) is free but first-come, first-served, so arrive early
        for the best spot.
      </p>

      {/* Replace with local asset */}
      <figure className="blog-figure">
        <img
          src="/imgs/blog/keeneland/starting-gate.jpeg"
          alt="Keeneland starting gate"
          loading="lazy"
        />
        <figcaption className="blog-figcaption">
          Keeneland starting gate
        </figcaption>
      </figure>

      <p>
        If you plan to see the races in person, plan far in advance for any
        reserved tables or box seats as they go quickly. General admission is
        much more affordable and manageable, though, and may be the best way to
        really experience Keeneland and abide by their slogan —{" "}
        <em>“racing as it was meant to be.”</em>
      </p>

      <p>
        Be sure to download the app so that you can easily place bets on the
        races without leaving your seat!
      </p>

      <p>
        The history and venue are rich, but you don’t have to be! Check out
        ticket prices and begin planning your experience of this signature
        American pastime. A trip to Keeneland could easily be that day you and
        your friends or family need to kick off spring or ring in autumn.
      </p>

      <div className="blog-callout">
        <strong>Also featured:</strong> This post also appears in{" "}
        <a
          href="https://www.haushomemagazine.com"
          target="_blank"
          rel="noreferrer"
        >
          Haus &amp; Home Magazine
        </a>
        .
      </div>
    </div>
  );
}
